import React from 'react';
import NoSolutionSelected from '../../List/components/NoSolutionSelected';
import Policy from './Policy';
import PerformanceReporting from './PerformanceReporting';
import { useManageSolutionsContext } from '../../context';

// Base RiskPool solution keys
const BASE_RISK_POOL_SOLUTIONS = ['policy'];

// Performance Reporting solution key (conditionally available based on feature flag)
const PERFORMANCE_REPORTING_SOLUTION = 'performance-reporting';

/**
 * Get the list of available RiskPool solution keys based on feature flags
 * @param isFeatureEnabled - Function to check if a feature is enabled
 * @returns Array of solution keys available for RiskPool organizations
 */
export function getRiskPoolAvailableSolutions(isFeatureEnabled: (featureId: string) => boolean): string[] {
  const solutions = [...BASE_RISK_POOL_SOLUTIONS];

  // Add Performance Reporting if the feature flag is enabled
  if (isFeatureEnabled('risk_pool_performance_reporting')) {
    solutions.push(PERFORMANCE_REPORTING_SOLUTION);
  }

  return solutions;
}

// Legacy export for backwards compatibility (shows all possible solutions)
export const RISK_POOL_AVAILABLE_SOLUTIONS = [...BASE_RISK_POOL_SOLUTIONS, PERFORMANCE_REPORTING_SOLUTION];

const RiskPool: React.FC = () => {
  const { selectedSolution } = useManageSolutionsContext();

  // No solution selected state
  if (!selectedSolution) {
    return <NoSolutionSelected />;
  }

  const solutionKey = selectedSolution.key;

  // Render the appropriate component based on solution key
  switch (solutionKey) {
    case 'policy':
      return <Policy />;
    case 'performance-reporting':
      return <PerformanceReporting />;
    default:
      return <NoSolutionSelected />;
  }
};

export default RiskPool;
